import React, { Fragment, useEffect, useState } from "react";
import { Container, Row, Col, Card, Nav } from "reactstrap";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import Breadcrumb from "../../../../layout/breadcrumb";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  getOrderCloseReasonSettings,
  storeCloseReason,
  updateCloseReason,
  deleteCloseReason,
  openEditDialog,
  openNewDialog,
  closeEditDialog,
} from "../store/closeReasonSettingSlice";
import withReducer from "../../../../store/withReducer";
import orderSettingReducer from "../store/store";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import CloseReasonsSettingFrom from "./closeReasonForm";

const defaultValues = {
  id: "",
  reason: "",
};
const dataMenu = [
  {
    type: 0,
    text: "Order",
    link: "/order",
  },
  {
    type: 1,
    text: "Order Setting",
    link: "",
  },
  {
    type: 1,
    text: "Close Reason",
    link: "",
  },
];
const schema = yup.object().shape({
  reason: yup.string().required("This is required field"),
});
const CloseReason = () => {
  const [closeReasons, setCloseReasons] = useState([]);
  const [isCreated, setIsCreated] = useState(false);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    formState,
    reset,
    control,
    register,
    setValue,
    trigger,
    getValues,
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors } = formState;
  const closeDialog = () => {
    dispatch(closeEditDialog());
  };

  const onSubmitForm = (dialog, data) => {
    const formData = {
      id: data.id,
      reason: data.reason,
    };
    if (dialog.type === "new") {
      dispatch(storeCloseReason({ ...formData })).then((res) => {
        if (!res.error) {
          setIsCreated(true);
          closeDialog(dialog.type);
        }
      });
    } else {
      dispatch(updateCloseReason({ ...formData })).then((res) => {
        if (!res.error) {
          closeDialog(dialog.type);
          setIsCreated(true);
        }
      });
    }
  };

  const onEdit = (row) => {
    dispatch(openEditDialog(row));
  };

  const onDelete = (row) => {
    dispatch(deleteCloseReason(row.id));
    setIsCreated(true);
  };

  useEffect(() => {
    dispatch(getOrderCloseReasonSettings()).then((res) => {
      console.log("Res ", res);
      setCloseReasons(res.payload);
      setIsCreated(false);
    });
  }, [dispatch, isCreated]);

  const tableColumns = [
    {
      name: "Reason",
      selector: (row) => row.reason,
      sortable: true,
      center: false,
    },
  ];

  return (
    <Fragment>
      <Container fluid className="">
        <Breadcrumb data={dataMenu} title="Close Reason" />
        <div>
          <div>
            <Row>
              <Col sm="12">
                <Card>
                  <Row>
                    <Col sm="6">
                      <Nav tabs className="border-tab"></Nav>
                    </Col>
                    <Col sm="6">
                      <div className="float-sm-right p-3">
                        <a
                          className="btn btn-sm btn-primary"
                          onClick={() => {
                            dispatch(openNewDialog());
                          }}
                        >
                          {" "}
                          <i className="fa fa-plus"></i> Add New Reason
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>

            <CommonDataTable
              headerColumns={tableColumns}
              gridData={closeReasons}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </div>
          <ModalFormSubmit
            defaultValues={defaultValues}
            schema={schema}
            formState={formState}
            handleSubmit={handleSubmit}
            onSubmitForm={onSubmitForm}
            noAction
            reset={reset}
            title="Close Reason"
            selector="orderSetting"
            dialog={({ closeReasonSetting }) =>
              closeReasonSetting.closeReasonSetting.addDialog
            }
            closeDialog={closeDialog}
            setValue={setValue}
            getValues={getValues}
            btnText="Save"
          >
            <CloseReasonsSettingFrom
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
              trigger={trigger}
              getValues={getValues}
            />
          </ModalFormSubmit>
        </div>
      </Container>
    </Fragment>
  );
};

export default withReducer([{ closeReasonSetting: orderSettingReducer }])(
  CloseReason
);
